import debounce from 'lodash.debounce'
import {
  setCookie,
} from '@utils/cookies'

export const ACTIVE_PRODUCT_COOKIE_NAME = 'TOTIS2.active_product'

export const toggleDetails = {
  bind(el, binding, vnode) {
    el.addEventListener('click', () => {
      const details = document.getElementById('details')
      details.removeAttribute('open')
      const inputs = Array.from(document.getElementsByClassName('product-weight-select__el'))
      inputs.forEach(input => input.removeAttribute('checked'))
      document.getElementById(el.getAttribute('for')).setAttribute('checked', 'checked')
    })
  },
}

export const toggleWeight = {
  bind(el, binding, vnode) {
    el.addEventListener('click', e => {
      const isProductToggler = el.closest('.js-product-details-main')

      e.preventDefault()

      const parent = vnode.elm.closest(el.dataset.parent)
      const needUrlReplace = el.dataset.replace

      const allTriggers = Array.from(parent.getElementsByClassName('variant-trigger'))
      const filteredTriggers = isProductToggler ? allTriggers.filter(a => !a.closest('.js-product-card')) : allTriggers

      filteredTriggers.forEach(trigger => {
        trigger.classList.remove('is-active')
      })

      el.classList.add('is-active')

      const allWeights = Array.from(parent.getElementsByClassName('variant-view'))
      const filteredWeight = isProductToggler ? allWeights.filter(a => !a.closest('.js-product-card')) : allWeights

      vnode.context.date = new Date()

      filteredWeight.forEach(w => {
        w.classList.remove('is-active')

        if (w.dataset.weight == binding.value) {
          w.classList.add('is-active')

          parent.dataset[w.dataset.key] = w.dataset.val
          // set not-available class when quantity zero
          if (w.dataset.count) {
            if (1 > w.dataset.count) {
              parent.classList.add('not-available')

              return
            }
            parent.classList.remove('not-available')
          }
        }
      })
      // if (!needUrlReplace) return
      // console.log(el)
      // const url = new URL(window.location)
      // url.searchParams.set('variant', binding.value)
      const href = el.getAttribute('href')

      if (href && needUrlReplace) {
        window.history.pushState({}, '', href)
      }

      setCookie(ACTIVE_PRODUCT_COOKIE_NAME, binding.value, 1)
    })
  },
}

const ZERO = 0
// const OFFSET = 24
const hoverEffect = el => {
  if (el.classList.contains('is-active')) return

  el.classList.add('is-active')
}
const antiHoverEffect = el => {
  const hover = el.getElementsByClassName('simple-hover')[0]
  el.classList.remove('is-active')
  hover.style.marginBottom = ZERO
}
const clearAllHovers = () => new Promise(res => {
  const cards = Array.from(document.getElementsByClassName('product'))
  cards.forEach(el => antiHoverEffect(el))
  res(true)
})

const getDataset = el => el.getElementsByClassName('product__link is-active')[0].dataset

const goToProductPage = (el, e) => {
  if (
    e.target.classList.contains('product__link')
  ) {
    // el.classList.contains('is-active') &&
    const { weight } = getDataset(el)
    setCookie(ACTIVE_PRODUCT_COOKIE_NAME, weight, 1)
    // window.location.href = e.target.href
  }
}

// product card

export const cardHover = {
  bind(el) {
    el.addEventListener('click', e => goToProductPage(el, e))
    // if (
    //   navigator.maxTouchPoints > ZERO ||
    //   navigator.msMaxTouchPoints > ZERO
    // ) {
    //   el.addEventListener('click', e => {
    //     e.preventDefault()
    //     goToProductPage(el, e)
    //     clearAllHovers().then(() => hoverEffect(el, vnode))
    //   })
    //   return
    // }
    el.addEventListener('auxclick', e => goToProductPage(el, e))

    // el.addEventListener('mouseenter', () => {
    //   hoverEffect(el, vnode)
    // })
    // el.addEventListener('mouseleave', () => {
    //   antiHoverEffect(el, vnode)
    // })
  },
}

// fot ui-table
export const toggleActivity = {
  bind(el, binding, vnode) {
    el.addEventListener('click', () => {
      const ref = vnode.context.$refs[binding.value]
      const $s = ref[0]
      if ($s) {
        if ($s.classList.contains('is-active')) {
          $s.classList.remove('is-active')
          return
        }
        $s.classList.add('is-active')
      }
    })
  },
}
// lifehack - dummy directive
export const lazy = {
  bind() {

  },
}

// client/src/pug/templates/staff/profile_detail_base.pug:51
// show phone and email - for analytics

export const toggler = {
  bind(el) {
    el.addEventListener('click', () => {
      const parent = el.parentElement.parentElement
      const [child] = parent.getElementsByClassName('staff-contact__val--full')
      child.classList.add('is-active')
      el.parentElement.classList.remove('is-active')
    })
  },
}

function checkSize(selector) {
  return true
  // return (selector.parentElement && selector.offsetWidth > selector.parentElement.offsetWidth)
}

export const tableWrapper = {
  bind(el, binding, vnode) {
    const tables = Array.from(el.getElementsByTagName('table'))
    if (tables.length) {
      tables.forEach(element => {
        if (checkSize(element)) {
          const parent = element.parentNode
          const wrapper = document.createElement('div')
          wrapper.classList.add('scroller')
          parent.replaceChild(wrapper, element)
          wrapper.appendChild(element)
        }
      })
    }
  },
}

export const stepScroll = {
  bind(el) {
    let currentIndex = 0
    let autoScrollInterval = null
    // let alreadyViewed = false

    const items = el.querySelectorAll('.js-step-item')
    const images = el.querySelectorAll('.js-step-image')

    function startAutoScroll() {
      autoScrollInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % items.length

        activateItem(currentIndex)
      }, 5000)
    }

    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval)
        autoScrollInterval = null
      }
    }

    function activateItem(index) {
      let finalIndex = index

      if (index >= items.length) {
        finalIndex = 0
      } else if (0 > index) {
        finalIndex = items.length - 1
      }

      items.forEach(item => {
        item.classList.remove('is-active')
      })

      images.forEach(item => {
        item.classList.remove('is-active')
        item.classList.remove('is-previous')
        item.classList.remove('is-next')
      })

      items[index].classList.add('is-active')

      if (images[index - 1]) {
        images[index - 1].classList.add('is-previous')
      }

      images[index].classList.add('is-active')

      if (images[index + 1]) {
        images[index + 1].classList.add('is-next')
      }

      currentIndex = finalIndex
    }

    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        stopAutoScroll()

        activateItem(index)

        startAutoScroll()
      })
    })

    activateItem(currentIndex)

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          startAutoScroll()
        } else {
          stopAutoScroll()
        }
      })
    }, { threshold: 0.1 })

    observer.observe(el)

    // const isDesktop = 1200 <= window.innerWidth

    // if (!isDesktop) return

    // const changeSlide = () => {
    //   currentIndex++

    //   activateItem(currentIndex)

    //   if (currentIndex === items.length - 1) {
    //     const sectionAfterScroll = Array.from(document.getElementsByClassName('js-section-after-scroll'))

    //     sectionAfterScroll.forEach(s => {
    //       s.classList.remove('is-hidden-xl')
    //     })

    //     alreadyViewed = true
    //   }
    // }

    // const debouncedHandleChange = debounce(changeSlide, 200)

    // function isSectionBottomNearViewport() {
    //   const rect = el.getBoundingClientRect()
    //   const viewportHeight = window.innerHeight || document.documentElement.clientHeight
    //   const distanceTopThreshold = 500
    //   const distanceBottomThreshold = 500

    //   if (rect.bottom >= viewportHeight - distanceBottomThreshold && rect.bottom <= viewportHeight + distanceTopThreshold) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }

    // function handleScroll(event) {
    //   if (alreadyViewed) return

    //   const isScrollDown = event.deltaY > 0

    //   if (isScrollDown && isSectionBottomNearViewport()) {
    //     if (currentIndex < items.length - 1) {
    //       event.preventDefault()

    //       setTimeout(() => {
    //         const rect = el.getBoundingClientRect()
    //         const viewportHeight = window.innerHeight || document.documentElement.clientHeight

    //         const sectionBottom = rect.bottom + window.scrollY + 200

    //         window.scrollTo({ top: sectionBottom - viewportHeight, behavior: 'smooth' })
    //       }, 0)

    //       debouncedHandleChange()
    //     }
    //   }
    // }

    // window.addEventListener('wheel', handleScroll, { passive: false })

    // el._scrollControlCleanup = () => {
    //   window.removeEventListener('wheel', handleScroll)
    // }
  },

  // unbind(el) {
  //   if (el._scrollControlCleanup) {
  //     el._scrollControlCleanup()
  //   }
  // }
}

export const menuButton = {
  bind(node) {
    node.addEventListener('click', () => {
      const findContent = item => contentItems.find(c => c.dataset.child === item.dataset.parent) || null

      const nodes = Array.from(document.getElementsByClassName('js-categories'))
      const mainNode = nodes.find(n => 'true' != n.dataset.static)
      const contentItems = Array.from(mainNode.getElementsByClassName('js-categories-content'))
      const items = Array.from(mainNode.getElementsByClassName('js-categories-item'))

      mainNode.classList.toggle('is-active')
      node.classList.toggle('is-active')

      items[0].classList.add('is-active')

      const content = findContent(items[0])

      if (content) {
        content.classList.add('is-active')
      }
    })
  },
}
// Многоуровневое (до 4+ уровней) "fat menu" с подсветкой всего активного пути
// Ожидается следующая структура атрибутов:
//
// .js-categories-item:
//   data-node-id   — уникальный идентификатор этой ноды (menu.id / child.id / child2.id / ...)
//   data-parent-id — идентификатор родителя (или отсутствует/пустой для корневых элементов)
//
// .js-categories-content:
//   data-node-id   — идентификатор ноды, для которой эта панель показывает детей
//
// Пример:
//   <div class="js-categories-item"
//        data-node-id="10"
//        data-parent-id="5">
//   </div>
//
//   <div class="js-categories-content"
//        data-node-id="10">
//   </div>

export const categoriesMenu = {
  bind(node) {
    const items = Array.from(node.getElementsByClassName('js-categories-item'))
    const contentItems = Array.from(node.getElementsByClassName('js-categories-content'))
    const isMobile = window.matchMedia('(max-width: 1200px)').matches

    let activePathIds = new Set()

    const setEquals = (a, b) => {
      if (a.size !== b.size) return false
      for (const v of a) {
        if (!b.has(v)) return false
      }
      return true
    }

    const buildPathFromItem = startItem => {
      const pathIds = new Set()
      let current = startItem

      while (current) {
        const { nodeId } = current.dataset
        if (!nodeId) break

        pathIds.add(nodeId)

        const { parentId } = current.dataset
        if (!parentId) break

        current = items.find(i => i.dataset.nodeId === parentId) || null
      }

      return pathIds
    }

    const applyActivePath = pathIds => {
      activePathIds = pathIds

      items.forEach(item => {
        const { nodeId } = item.dataset
        const shouldBeActive = nodeId && activePathIds.has(nodeId)
        item.classList.toggle('is-active', !!shouldBeActive)
      })

      contentItems.forEach(content => {
        const { nodeId } = content.dataset
        const shouldBeActive = nodeId && activePathIds.has(nodeId)
        content.classList.toggle('is-active', !!shouldBeActive)
      })

      node.classList.toggle('is-active', activePathIds.size > ZERO)
    }

    const clearActivePath = () => {
      if (activePathIds.size === ZERO) return

      activePathIds = new Set()

      items.forEach(item => item.classList.remove('is-active'))
      contentItems.forEach(content => content.classList.remove('is-active'))
      node.classList.remove('is-active')
    }

    node.addEventListener('mouseover', () => {
      const isStatic = 'true' === node.dataset.static

      if (isStatic) {
        const nodes = Array.from(document.getElementsByClassName('js-categories'))
        const mainNode = nodes.find(n => 'true' !== n.dataset.static)

        if (mainNode) {
          mainNode.classList.add('is-active')
        }
      }
    })

    const handleDesktopHover = item => {
      const newPath = buildPathFromItem(item)
      applyActivePath(newPath)
    }

    const handleMobileClick = item => {
      const newPath = buildPathFromItem(item)

      if (setEquals(newPath, activePathIds)) {
        clearActivePath()
      } else {
        applyActivePath(newPath)
      }
    }

    const handleMouseLeaveRoot = e => {
      if (!node.contains(e.relatedTarget)) {
        clearActivePath()
      }
    }
    if (isMobile) {
      items.forEach(item => {
        item.addEventListener('click', event => {
          event.preventDefault()
          handleMobileClick(item)
        })
      })
    } else {
      items.forEach(item => {
        item.addEventListener('mouseenter', () => handleDesktopHover(item))
      })

      node.addEventListener('mouseleave', handleMouseLeaveRoot)
    }
  },
}

// export const categoriesMenu = {
//   bind(node) {
//     // node.addEventListener('mouseover', e => {
//     //   const isStatic = node.dataset.static == 'true'

//     //   if (isStatic) {
//     //     const nodes = Array.from(document.getElementsByClassName('js-categories'))

//     //     const mainNode = nodes.find(n => n.dataset.static != 'true')

//     //     mainNode.classList.add('is-active')
//     //   }
//     // })

//     const items = Array.from(node.getElementsByClassName('js-categories-item'))
//     const contentItems = Array.from(node.getElementsByClassName('js-categories-content'))

//     const isMobile = window.matchMedia('(max-width: 1200px)').matches

//     const findContent = (item, param = 'parent') => contentItems.find(c => c.dataset.child === item.dataset[param]) || null

//     const toggleActiveState = (item, content, shouldActivate) => {
//       items.forEach(i => i.classList.toggle('is-active', i === item && shouldActivate))

//       contentItems.forEach(c => c.classList.toggle('is-active', c === content && shouldActivate))

//       node.classList.toggle('is-active', shouldActivate)
//     }

//     // const handleMobileClick = item => {
//     //   const isActive = item.classList.contains('is-active')

//     //   toggleActiveState(item, findContent(item), !isActive)
//     // }

//     const handleDesktopHover = (item, shouldActivate) => {
//       toggleActiveState(item, findContent(item), shouldActivate)
//     }

//     // const handleMouseLeave = (e, item) => {
//     //   if (!node.contains(e.relatedTarget)) {
//     //     node.classList.remove('is-active')
//     //     items.forEach(i => i.classList.remove('is-active'))
//     //     contentItems.forEach(c => c.classList.remove('is-active'))
//     //   }
//     // }

//     // if (isMobile) {
//     //   items.forEach(item => {
//     //     item.addEventListener('click', () => handleMobileClick(item))
//     //   })
//     // } else {
//     const triggers = [
//       {
//         items,
//         key: 'parent',
//       },
//       {
//         items: contentItems,
//         key: 'child',
//       },
//     ]
//     triggers.forEach(param => {
//       param.items.forEach(item => {
//         const content = findContent(item, param.key)

//         item.addEventListener('mouseenter', () => handleDesktopHover(item, true))
//         // item.addEventListener('mouseleave', e => handleMouseLeave(e, item))
//         if (content) {
//           content.addEventListener('mouseenter', () => handleDesktopHover(item, true))
//           // content.addEventListener('mouseleave', e => handleMouseLeave(e, item))
//         }
//       })
//     })
//     //   // node.addEventListener('mouseleave', e => {
//     //   //   items.forEach(i => i.classList.remove('is-active'))

//     //   //   contentItems.forEach(c => c.classList.remove('is-active'))

//     //   //   node.classList.remove('is-active')
//     //   // })
//     // }
//   },
// }

export default {
  toggler,
  lazy,
  toggleActivity,
  toggleDetails,
  cardHover,
  toggleWeight,
  tableWrapper,
  stepScroll,
  categoriesMenu,
  menuButton,
}
